(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-quote-template"]) return;
  try {
    
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const product = urlParams.get('product')

  if (product != null) {
    const productInput = document.getElementById("productIdInput");
    productInput.value = product;
  } else {
    // document.location = '/'
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test"]) return;
  try {
    
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const product = urlParams.get('product')

  if (product != null) {
    const productInput = document.getElementById("productIdInput");
    productInput.value = product;
  } else {
    // document.location = '/'
  }

  } catch(e) { console.error(e); }
})();
})();
